import { Tooltip_Trigger_default } from "./chunk-JN4SSBSU.js";
import { Tooltip_default } from "./chunk-Z4F2XBNJ.js";

// src/components/Tooltip/index.ts
var TooltipComponent = Tooltip_default;
TooltipComponent.Trigger = Tooltip_Trigger_default;
TooltipComponent.Trigger.displayName = "Tooltip.Trigger";
export { TooltipComponent };